/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_Generatingcontent1Inputs */

const zh_preview_generatingcontent1 = /** @type {(inputs: Preview_Generatingcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成内容...`)
};

const en_preview_generatingcontent1 = /** @type {(inputs: Preview_Generatingcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating content...`)
};

const es_preview_generatingcontent1 = /** @type {(inputs: Preview_Generatingcontent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando contenido...`)
};

/**
* | output |
* | --- |
* | "Generating content..." |
*
* @param {Preview_Generatingcontent1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const preview_generatingcontent1 = /** @type {((inputs?: Preview_Generatingcontent1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_Generatingcontent1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_generatingcontent1(inputs)
	if (locale === "en") return en_preview_generatingcontent1(inputs)
	return es_preview_generatingcontent1(inputs)
});
export { preview_generatingcontent1 as "preview_generatingContent" }